/*
 * @Author: xxx xxx
 * @Date: 2022-12-28 16:38:14
 * @LastEditors: xxx xxx
 * @LastEditTime: 2023-02-28 11:29:55
 * @FilePath: \react-admin\src\routers\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Navigate, useRoutes } from "react-router-dom";
import { RouteObject } from "@/routers/interface";
import PrizeCardH5 from "../views/prizeCardH5/index";
import PrizeCardAreaH5 from "../views/prizeCardAreaH5/index";
import HomeView from "../views/home/index";
import PCH5 from "../views/PCH5/index";

// * 导入所有router
const metaRouters = import.meta.globEager("./modules/*.tsx");

// * 处理路由
export const routerArray: RouteObject[] = [];
Object.keys(metaRouters).forEach(item => {
	Object.keys(metaRouters[item]).forEach((key: any) => {
		routerArray.push(...metaRouters[item][key]);
	});
});

export const rootRouter: RouteObject[] = [
	{
		path: "/",
		element: <PCH5 />
	},
	{
		path: "/prizeCardH5",
		element: <PrizeCardH5 />,
		meta: {
			requiresAuth: false,
			title: "奖卡",
			key: "prizeCardH5"
		}
	},
	{
		path: "/pc",
		element: <PCH5 />,
		meta: {
			requiresAuth: false,
			title: "奖卡",
			key: "pc"
		}
	},
	{
		path: "/prizeCardAreaH5",
		element: <PrizeCardAreaH5 />,
		meta: {
			requiresAuth: false,
			title: "奖卡",
			key: "prizeCardAreaH5"
		}
	},
	{
		path: "*",
		element: <Navigate to="/404" />
	}
];

const Router = () => {
	const routes = useRoutes(rootRouter);
	return routes;
};

export default Router;
